<a [routerLink]="switchingLink" class="dropdown-control regular-10 d-flex justify-center align-items-center">
  <div class="display-container d-flex align-items-center justify-space-between fv-item clickable new-sidebar-icon">
    <ng-container *ngIf="!switcherLinkRegex.test(switchingLink); then dashboard else driverSettings"></ng-container>
    <ng-template #driverSettings>
      <i phx-icon [phxIcon]="personGearIcon"></i>
    </ng-template>
    <ng-template #dashboard>
      <i phx-icon [phxIcon]="dashboardIcon"></i>
    </ng-template>
  </div>
</a>
